import React from 'react';
import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

const UnderDevelop: React.FC = () => {
  const { t } = useTranslation();

  return <Result status="404" title={t('underdevelopment.title')} subTitle={t('underdevelopment.subTitle')} />;
};

export default UnderDevelop;
